import { Link, useParams } from 'react-router-dom';
import IconBack from '../../../../assets/Images/icons/icon-back';
import { ROUTER } from '../../../../constants/router';

import Steps from './components/Steps';
import { useTranslation } from 'react-i18next';

const TemplateTerm = () => {
    const { key } = useParams();
    const { t } = useTranslation('consent');
    return (
        <>
            <div className="title flex space-x-2">
                <div>
                    <Link to={`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}`}>
                        <IconBack />
                    </Link>
                </div>
                <div>
                    {key ? t('Edit Template Design') : t('Add Template Design')}
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    Consent Management /&nbsp;
                </span>
                <span className="text-sm text-gray-400">
                    Template Design /&nbsp;
                </span>
                Template Design
            </div>
            <Steps />
        </>
    );
};

export default TemplateTerm;
